export default __webpack_public_path__ + "static/media/home-web-agency-bg-img-02.c2651f12.jpg";